import { API } from "aws-amplify";

import {
  parseRequestSelectionKey,
  updateDraftCourseRequestField,
} from "./courseRequestDraftHelpers";

export const setCourseRequestInclusionInStudents = (
  students,
  selectionKey,
  courseID,
  isInclusion,
) => updateDraftCourseRequestField(
  students,
  selectionKey,
  courseID,
  "is_inclusion",
  isInclusion ? "1" : "0",
);

export const saveCourseRequestInclusion = async ({
  schoolInfo,
  selectionKey,
  courseID,
  isInclusion,
}) => {
  const { group_id, student_id } = parseRequestSelectionKey(selectionKey);
  const apiName = process.env.REACT_APP_ENDPOINT_NAME;

  return API.post(apiName, "/admin/update-requests", {
    response: true,
    body: JSON.stringify({
      school_id: schoolInfo.school_id,
      schedule_version_id: schoolInfo.current_schedule_version_id,
      update_type: "update_inclusion",
      student_id,
      group_id,
      course_id: courseID,
      is_inclusion: isInclusion ? "1" : "0",
    }),
  });
};
